import { ReactNode } from 'react';
import styles from './JourneyUploadCard.module.scss';

type JourneyUploadCardProps = {
    title: string;
    subtitle?: string;
    isInvestor?: boolean;
    children: ReactNode;
    /** 'row' places the title and children side by side (Bank tab's Fetch card). Defaults to stacked. */
    layout?: 'stacked' | 'row';
};

/**
 * Presentational card wrapper for the borrower Data Upload tabs (RECUR-28067 D6):
 * title, optional subtitle, and the tab's own content (dropzone + file list).
 *
 * The card wrapper swallows dragover/drop so a near-miss drop outside the dashed
 * dropzone neither navigates the browser to the file nor triggers an upload (R3) —
 * actual drop HANDLING stays on the dropzone only.
 */
const JourneyUploadCard = ({ title, subtitle, isInvestor, children, layout = 'stacked' }: JourneyUploadCardProps) => (
    <div
        style={isInvestor ? { width: '80%' } : {}}
        className={layout === 'row' ? styles.JourneyUploadCardRow : styles.JourneyUploadCard}
        onDragOver={(e) => e.preventDefault()}
        onDrop={(e) => e.preventDefault()}
    >
        {layout === 'row' ? (
            <>
                <div className={styles.Title}>{title}</div>
                {children}
            </>
        ) : (
            <>
                <div className={styles.Title}>{title}</div>
                {subtitle && <div className={styles.Subtitle}>{subtitle}</div>}
                {children}
            </>
        )}
    </div>
);

export default JourneyUploadCard;
